import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import BioPage from './pages/BioPage';
import BioDashboard from './pages/BioDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CollabOrderPage from './pages/CollabOrderPage';
import UnsubscribePage from './pages/UnsubscribePage';
import EmbedTestPage from './pages/EmbedTestPage';
import ShoutOutProfilePage from './pages/ShoutOutProfilePage';
import AccountPage from './pages/AccountPage';
import SupportPage from './pages/SupportPage';
import MessagePage from './pages/MessagePage';
import StartPage from './pages/StartPage';

function App() {
  return (
    <Router>
      <Toaster 
        position="top-center" 
        toastOptions={{
          style: {
            background: '#1f2937',
            color: '#fff',
            borderRadius: '12px',
          },
        }}
      />
      <Routes>
        <Route path="/dashboard" element={<BioDashboard />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/start" element={<StartPage />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/test" element={<EmbedTestPage />} />
        <Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
        <Route path="/collab/:username/:serviceId" element={<CollabOrderPage />} />
        <Route path="/:username/shoutout" element={<ShoutOutProfilePage />} />
        <Route path="/:username/message" element={<MessagePage />} />
        <Route path="/:username/support" element={<SupportPage />} />
        <Route path="/:username/privacy" element={<PrivacyPolicy />} />
        <Route path="/:username" element={<BioPage />} />
      </Routes>
    </Router>
  );
}

export default App;

